var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExternalicon = function SvgExternalicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m2.4 9.979-.379-.38a.268.268 0 0 1 0-.378l6.127-6.127-3.368.003a.268.268 0 0 1-.27-.269l.005-.534a.268.268 0 0 1 .269-.269l4.649-.004c.107 0 .209.043.284.118l.144.144a.413.413 0 0 1 .118.284l-.004 4.65a.268.268 0 0 1-.27.268h-.537a.263.263 0 0 1-.265-.265l.003-3.368L2.78 9.979a.268.268 0 0 1-.379 0Z"
  })));
};
export default SvgExternalicon;